
import ArrowCircleRight from "../../../assets/filled/ArrowCircleRight.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowCircleRightIcon({ className, dataTestid = "ArrowCircleRightIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowCircleRight data-testid={dataTestid} className={classes} {...rest} />
  );
}
